export default "__VITE_ASSET__5c0f7c21__"